'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddWebItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseAlerts = require('@bibliocommons/base-alerts');

var _baseIcons = require('@bibliocommons/base-icons');

var _sharedJacketCover = require('@bibliocommons/shared-jacket-cover');

var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);

var _baseButtons = require('@bibliocommons/base-buttons');

var _itemAnnotationInput = require('../../item-annotation-input');

var _itemAnnotationInput2 = _interopRequireDefault(_itemAnnotationInput);

var _urlInput = require('../../url-input');

var _urlInput2 = _interopRequireDefault(_urlInput);

var _webItemTitleInput = require('../../web-item-title-input');

var _webItemTitleInput2 = _interopRequireDefault(_webItemTitleInput);

require('../styles/AddWebItem.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddWebItem = exports.AddWebItem = function (_BcReactComponent) {
  _inherits(AddWebItem, _BcReactComponent);

  function AddWebItem(props) {
    _classCallCheck(this, AddWebItem);

    var _this = _possibleConstructorReturn(this, (AddWebItem.__proto__ || Object.getPrototypeOf(AddWebItem)).call(this, props));

    _this.bindAll('handleAddBib', 'handleAnnotationChange', 'handleAddWebItem');
    return _this;
  }

  _createClass(AddWebItem, [{
    key: 'handleAddBib',
    value: function handleAddBib(item) {
      this.props.handleAddBib(item);
    }
  }, {
    key: 'handleAnnotationChange',
    value: function handleAnnotationChange(value) {
      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ annotation: value }));
    }
  }, {
    key: 'handleAddWebItem',
    value: function handleAddWebItem() {
      if (this.webItemIsValid()) {
        this.props.handleAddWebItem();
      }
    }
  }, {
    key: 'webItemIsValid',
    value: function webItemIsValid() {
      var webItem = this.props.webItem;

      return webItem.get('url') && webItem.getIn(['jacketCover', 'localUrl']) && !webItem.get('invalidURL');
    }
  }, {
    key: 'webItemIsAlreadyOnList',
    value: function webItemIsAlreadyOnList() {
      var _props = this.props,
          webItem = _props.webItem,
          listItems = _props.listItems;

      var existingItemIndex = listItems.findIndex(function (item) {
        return item.getIn(['urlListItem', 'url', 'url']) === webItem.get('url');
      });

      return existingItemIndex !== -1;
    }
  }, {
    key: 'renderAddButton',
    value: function renderAddButton() {
      var webItem = this.props.webItem;

      return _react2.default.createElement(
        _baseButtons.PrimaryButton,
        {
          className: 'add-url',
          disabled: !this.webItemIsValid() || !webItem.get('title') || this.webItemIsAlreadyOnList(),
          'data-test-id': 'add-web-item-button',
          handleClick: this.handleAddWebItem },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'add' })
      );
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      var webItem = this.props.webItem;

      // Check if URL is valid
      if (webItem.get('invalidURL')) {
        return _react2.default.createElement(
          _baseAlerts.AlertFailure,
          null,
          _react2.default.createElement(
            'span',
            { 'data-test-id': 'web-item-error' },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_error_invalid_url' })
          )
        );
      }

      // Check if URL is already on list
      if (webItem.get('validated') && this.webItemIsAlreadyOnList()) {
        return _react2.default.createElement(
          _baseAlerts.AlertFailure,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_error_url_already_on_list' })
        );
      }

      // Display spinner if still waiting for previewURL
      if (webItem.get('validating')) {
        return _react2.default.createElement(_baseIcons.Spinner, { className: 'image-spinner' });
      }

      // Show preview
      if (webItem.get('url') && webItem.getIn(['jacketCover', 'localUrl'])) {
        return _react2.default.createElement(
          'div',
          { className: 'preview row' },
          _react2.default.createElement(
            'div',
            { className: 'pull-left' },
            _react2.default.createElement(_sharedJacketCover2.default, { format: 'WEBSITE', src: webItem.getIn(['jacketCover', 'localUrl']) })
          ),
          _react2.default.createElement(
            'div',
            { className: 'item-details' },
            _react2.default.createElement(
              'span',
              { className: 'info-field website-title' },
              _react2.default.createElement(_webItemTitleInput2.default, {
                value: webItem.get('title'),
                handleWebItemPropertyChange: this.props.handleWebItemPropertyChange })
            ),
            _react2.default.createElement(
              'span',
              { className: 'info-field url' },
              webItem.get('url')
            ),
            _react2.default.createElement(
              'span',
              { className: 'info-field format' },
              _react2.default.createElement('i', { 'aria-hidden': true, className: 'icon-export' }),
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'list_web_resource' })
            ),
            _react2.default.createElement(_itemAnnotationInput2.default, {
              allowFreeText: true,
              value: this.props.webItem.get('annotation'),
              handleChange: this.handleAnnotationChange })
          )
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'render',
    value: function render() {
      var webItem = this.props.webItem;


      return _react2.default.createElement(
        'form',
        {
          action: '',
          className: 'cp-add-web-item',
          'data-test-id': 'add-web-item-form',
          onSubmit: AddWebItem.handleFormSubmit,
          'data-test-autopopulated': webItem.get('fieldsAutoPopulated') ? 'true' : 'false' },
        _react2.default.createElement(
          'div',
          { className: 'url-field' },
          _react2.default.createElement(_urlInput2.default, {
            value: webItem.get('url'),
            previewURL: webItem.getIn(['jacketCover', 'localUrl']),
            invalidURL: webItem.get('invalidURL'),
            handleWebItemPropertyChange: this.props.handleWebItemPropertyChange }),
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            {
              'data-test-id': 'web-item-submit-url-button',
              className: 'submit-url-button',
              handleClick: this.props.handleWebURLSelected },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_okay' })
          )
        ),
        this.renderPreview(),
        _react2.default.createElement(
          'div',
          { className: 'buttons row' },
          this.renderAddButton()
        )
      );
    }
  }], [{
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
    }
  }]);

  return AddWebItem;
}(_baseBcReactComponent2.default);

AddWebItem.propTypes = {
  listItems: _reactImmutableProptypes2.default.listOf(_bcPropTypes.listItemShape).isRequired,
  webItem: _reactImmutableProptypes2.default.contains({
    type: _react.PropTypes.string,
    title: _react.PropTypes.string,
    annotation: _react.PropTypes.string,
    url: _react.PropTypes.string,
    jacketCover: _reactImmutableProptypes2.default.contains({ localUrl: _react.PropTypes.string })
  }),

  handleAddWebItem: _react.PropTypes.func.isRequired,
  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
  handleWebURLSelected: _react.PropTypes.func.isRequired
};

exports.default = AddWebItem;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-web-item/components/AddWebItem.component.js
// module id = 1274
// module chunks = 0